// extracted by mini-css-extract-plugin
module.exports = {"simplified-banner":"_93444fe79c--simplified-banner--kHmBw"};